const indexItems = [
  { label: '热播新番', count: '50+', icon: 'ri-fire-line' },
  { label: '经典老番', count: '200+', icon: 'ri-history-line' },
  { label: '剧场版', count: '80+', icon: 'ri-film-line' },
  { label: 'OVA合集', count: '60+', icon: 'ri-dvd-line' },
  { label: '热血战斗', count: '120+', icon: 'ri-sword-line' },
  { label: '治愈日常', count: '90+', icon: 'ri-heart-line' },
  { label: '悬疑推理', count: '45+', icon: 'ri-search-eye-line' },
  { label: '搞笑喜剧', count: '70+', icon: 'ri-emotion-laugh-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            主题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型快速找到想看的动漫在线看内容
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 text-center cursor-pointer hover:border-primary-200/60 hover:bg-white transition-all duration-300 group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 group-hover:bg-accent-100 transition-colors duration-300">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1 whitespace-nowrap">
                {item.label}
              </h3>
              <span className="text-xs text-foreground-500">{item.count}部</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}